import { BrowseResult } from '@iwentsourcing/core/storage/browse-result.js';
import { StateValue } from '@iwentsourcing/core/storage/state-value.js';
import { mapToState } from '@iwentsourcing/core/runtime/get-state-data-keys.js';
import { StateDefinition } from '@iwentsourcing/core/storage/state-declaration.js';
import { DataSet } from '@iwentsourcing/core/storage/data-set.js';
import { RangeOptions } from '@iwentsourcing/core/storage/range-options.js';
import { Telemetry } from '@iwentsourcing/core/tracer/telemetry.js';

export async function* iterateResponse<
  TState extends StateDefinition<any, any, any>,
>(
  state: TState,
  bookmark: Record<string, StateValue> | null,
  opts: RangeOptions,
  req: (
    bookmark: Record<string, StateValue> | null,
    opts: RangeOptions,
  ) => Promise<BrowseResult<Record<string, StateValue>>>,
  telemetry: Telemetry,
): AsyncGenerator<DataSet<TState>> {
  const options: RangeOptions = {
    dir: opts?.dir ?? 'next',
    open: opts?.open ?? false,
    signal: opts.signal,
  };

  let currentBookmark = bookmark;
  do {
    const response = await req(currentBookmark, options);

    for (const item of response.items) {
      yield {
        data: mapToState(state, item.data, telemetry),
        keys: item.keys,
      };
    }
    currentBookmark = response.bookmark;
    if (response.items.length < 10) {
      break;
    }
  } while (true);
}
